import { PROMISE_STATUS, NUMBER } from "../../../constants/app-constants";
import { getFilteredData, parseChargesAndHoldbacks } from "../post-inspection-diy/selector";
import { PURCHASE_REQUEST_STATUS } from "../../../constants/seller-diy-constants";
import { FRANCHISE_BOUGHT_STATUS } from "../post-inspection-franchise-price-tab/constant";
import isObjectEmpty from "../../../utils/helpers/isObjectEmpty";

export const getResolvedPromiseData = (promiseResponse) => {
    if (promiseResponse.status === PROMISE_STATUS.FULFILLED && promiseResponse.value) {
        return promiseResponse.value;
    }
    return {};
};

export const getParsedPriceBreakup = ({
    priceBreakup = {},
    showServiceCharge = true,
    challanDetails = {},
    offeredPrice = "",
    deductions = {}
}) => {

    const { deductions: chargesAndHoldback, additions } = priceBreakup || {};
    const { charges, holds, totalCharges, totalHolds, serviceChargeAmount, videos } = parseChargesAndHoldbacks(chargesAndHoldback, showServiceCharge) || {};
    const { offers: offer = [] } = additions || {};
    const { data: offers, totalCount: totalOffers } = getFilteredData(offer);

    return {
        ...priceBreakup,
        deductions: {
            ...deductions,
            charges,
            holds,
            totalCharges,
            totalHolds,
            serviceChargeAmount,
            offers,
            totalOffers,
            ...challanDetails
        },
        priceAfterDeductions: offeredPrice ? offeredPrice + totalOffers - totalCharges : 0,
        videoLinks: videos
    };
};

export const covert24hTo12h = (time) => {
    let timeString = time;
    const H = +timeString.substr(0, NUMBER.TWO);
    const h = (H % NUMBER.TWELVE) || NUMBER.TWELVE;
    const ampm = H <  NUMBER.TWELVE ? " AM" : " PM";
    timeString = h + ampm;
    return timeString;
};

export const getCurrentTab = ({ purchaseRequestStatus, isDeliveryApproved, status, isVerified = false}) => {
    if (isDeliveryApproved) return NUMBER.THREE;
    if (purchaseRequestStatus === PURCHASE_REQUEST_STATUS.CREATED) return NUMBER.TWO;
    if (isVerified) return NUMBER.THREE;
    if (status === FRANCHISE_BOUGHT_STATUS.PRICE_CONSENT_ACCEPTED) return NUMBER.TWO;
    if (status === FRANCHISE_BOUGHT_STATUS.CAR_SOLD) return NUMBER.THREE;
    if (status === FRANCHISE_BOUGHT_STATUS.IN_NEGOTIATION) return NUMBER.ONE;
    return NUMBER.ONE;
};

export const getHeaderText = (carDetails) => {
    if (isObjectEmpty(carDetails)) return ``;

    const {
        year = "",
        make: makeName = "",
        model: modelName = ""
    } = carDetails || {};

    if (carDetails) return `${year ? year : ""} ${makeName ? makeName : ""} ${modelName ? modelName : ""} `;
    return "";
};
